/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable no-extra-parens */
import React, { lazy } from 'react';
import { WidgetLazyLoadWrapper } from '../common/utilities/widgetLazyLoadWrapper';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import styled from 'styled-components';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

const StoryWidgetScreen = lazy(() => import('./storySectionWidget'));

export const StoryWidgetLazy = () => {
    return (
        <WidgetLazyLoadWrapper suspenseFallbackLoadingUI={<StoryWidgetLoadingUI />}>
            <StoryWidgetScreen />
        </WidgetLazyLoadWrapper>
    );
};

const StoryWidgetLoadingUI = () => {
    return (
        <LoadingContainer>
            <AnimatedLoadingPlaceholder height='100%' radius={3} />
        </LoadingContainer>
    );
};

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background: #ffffff;
    height: 600px;
    width: 100%;
    @media ${smallMediaQuery} {
        height: 1087px;
    }
`;